import { ApiGatewayError } from './api-gateway.error';

export class NotFoundError extends ApiGatewayError {
  static override key = 'notFound';

  override get details() {
    return {
      ...super.details,
      field: 'id',
      value: this.record?.['id'],
    };
  }
}
